<template>
  <!--
    Issue to get the value of the input, due to the data-toggle from bootstrap.

    Changes:
    - Removed `data-toggle="buttons"`
    - Adapted styles
    - Value prop: accept NUmber type
  -->
  <div class="btn-group-toggle">
    <label class="btn" :class="[{ active: value }, buttonClasses]">
      <input v-model="model" type="checkbox" checked="" autocomplete="off">
      <slot></slot>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'button-checkbox',
    props: {
      value: {
        type: [Boolean, Number],
        description: 'Checked value'
      },
      buttonClasses: {
        type: [String, Object],
        description: 'Inner button css classes'
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('change', val)
        }
      }
    }
  }
</script>

<style scoped>
  .btn-group-toggle .btn:not(.active) {
      color: #525f7f;
  }
  .btn-group-toggle .btn {
      background-color: #f6f9fc;
      cursor: pointer;
      box-shadow: none;
      border: 0;
      margin: 0;
  }
  .btn-group-toggle .btn.active {
    background-color: #5e72e4;
    color: #fff;
  }
</style>
